import { render } from "./GeolocationEmbed.vue?vue&type=template&id=dbeb1e6c&scoped=true"
import script from "./GeolocationEmbed.vue?vue&type=script&lang=js"
export * from "./GeolocationEmbed.vue?vue&type=script&lang=js"

import "./GeolocationEmbed.vue?vue&type=style&index=0&id=dbeb1e6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbeb1e6c"]])

export default __exports__